<template>
	<div class="leoshop leopages">
		<LeoHandB title="当地直销更省钱" curactive="myshop">
			<div slot="content">
				<van-sticky :offset-top="44">
					<div class="leoshop-t" style="padding: 0;" :style="'background-color:'+gcfg.BackgroundColor">
						<div class="gd-top" style="display: flex;align-items: center;"
							:style="'background-color:'+gcfg.BackgroundColor">
							<div class="searchbox" style="flex: 1;">
								<div class="searchbox-item">
									<div class="lefticon">
										<van-icon name="search" />
									</div>
									<div class="righttitle" @click="goSearchPage">
										<span>点击搜索</span>
									</div>
								</div>
							</div>
							<div class="lefttext" @click="onCell" style="padding-right: 15px;">
								<van-icon name="phone" size="20px" color="#00aa00" style="vertical-align: middle;" />
								<span style="font-size: 13px;color: #000;">联系店主</span>
							</div>
						</div>
						<div class="shop-xx" style="padding: 10px 15px;" v-if="store != null && store != undefined">
							<div class="shop-tx">
								<van-image :src="store.avatar" fit="scale-down" />
							</div>
							<div class="shop-xq" :style="'color:'+gcfg.TopTextColor">
								<div class="shop-name" @click="goShopNamePage">
									<p class="name-p">
										<span class="name ells">{{store.storename}}</span>
										<span class="name-go">
											<!-- <van-icon name="arrow" /> -->
										</span>
									</p>
									<p class="shop-name-tips ells">{{store.notice}}</p>
								</div>
								<div class="btns">
									<van-button round @click="isFxShow =true">
										<van-icon name="share-o" />
										分享
									</van-button>
								</div>
							</div>
						</div>
					</div>
				</van-sticky>
				<div class="leoshop-content">
					<van-swipe class="swipebox" v-if="bannerone.length>0" :autoplay="3000" lazy-render>
						<van-swipe-item v-for="(item,index) in bannerone" :key="index">
							<a :href="item.url"><img :src="item.image" /></a>
						</van-swipe-item>
					</van-swipe>
					<div class="grid-box grid-box5">
						<div class="grid-item grid-item5 bgcolor" v-for="(item,index) in recommendData" :key="index"
							@click="goPageList(index)">
							<van-icon v-if="item.name.indexOf('门票') != -1" class="van-icon iconfont" name="ziyuan3"
								class-prefix="icon" />
							<van-icon v-else-if="item.name.indexOf('酒店') != -1" class="van-icon iconfont" name="jiudian"
								class-prefix="icon" />
							<van-icon v-else-if="item.name.indexOf('度假') != -1" class="van-icon iconfont" name="lvyou1"
								class-prefix="icon" />
							<van-icon v-else-if="item.name.indexOf('美食') != -1" class="van-icon iconfont"
								name="meishika" class-prefix="icon" />
							<van-icon v-else-if="item.name.indexOf('包车') != -1" class="van-icon iconfont" name="yongche"
								class-prefix="icon" />
							<van-icon v-else-if="item.name.indexOf('拍') != -1" class="van-icon iconfont" name="xiangji"
								class-prefix="icon" />
							<van-icon v-else-if="item.name.indexOf('直通车') != -1" class="van-icon iconfont"
								name="zhitongche" class-prefix="icon" />
							<van-icon v-else-if="item.name.indexOf('特产') != -1" class="van-icon iconfont"
								name="tutechan" class-prefix="icon" />
							<van-icon v-else-if="item.name.indexOf('晚会') != -1" class="van-icon iconfont" name="wutai"
								class-prefix="icon" />
							<van-icon v-else-if="item.name.indexOf('巴士') != -1" class="van-icon iconfont" name="bus"
								class-prefix="icon" />
							<van-icon v-else class="van-icon iconfont" name="weibiaoti1" class-prefix="icon" />
							<p class="name">{{item.name}}</p>
						</div>
					</div>

					<div style="margin: 10px;">
						<div class="box-tow" v-if="ggitems.length>0">
							<div class="gg-item" v-for="(item,index) in ggitems" :key="index">
								<a :href="item.url"><img :src="item.image"></a>
							</div>
						</div>
						<van-swipe class="swipebox" v-if="bannertow.length>0" style="height: 100px;" :autoplay="3500"
							lazy-render>
							<van-swipe-item v-for="(item,index) in bannertow" :key="index">
								<a :href="item.url"><img :src="item.image" /></a>
							</van-swipe-item>
						</van-swipe>
					</div>

					<div class="listdata">
						<div class="listdata-title" :style="'background-color:'+gcfg.BackgroundColor">
							<span :style="'color:'+gcfg.TopTextColor">热销推荐</span>
						</div>
						<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
							:immediate-check="false">
							<van-cell v-for="(item,index) in list" :key="index">
								<div class="cell-item" @click="goGoodsDetail(item.goods_id)">
									<div class="leftimg">
										<van-image :src="item.images" fit="cover"></van-image>
									</div>
									<div class="right-content">
										<div class="title ells">
											{{item.goods_name}}
										</div>
										<div class="remark" style="overflow: hidden;">
											<p class="ells" v-for="desc in item.describe.split('<br/>')">
												{{desc}}
											</p>
										</div>
										<div class="xse">
											已售：<span>{{item.sales}}</span>份
										</div>
										<div class="price">
											<div class="xj">
												<!-- 原价<span>￥{{item.line_price}}</span> -->
												￥<span>{{item.goods_price}}</span>
												起
											</div>
											<div class="xj">
												<!-- ￥<span>{{item.goods_price}}</span> -->
											</div>
										</div>
									</div>
								</div>
							</van-cell>
						</van-list>

					</div>
				</div>
			</div>
		</LeoHandB>
		<van-popup @click="isFxShow=false" v-model="isFxShow" style="width: 100%;height: 100%;">
			<img style="width: 100%;height: 100%;" src="@/assets/img/fx.jpg" alt="">
			<!-- <van-image style="width: 100%;height: 100%;" src="@/assets/img/fx.png" alt="二维码" /> -->
		</van-popup>
	</div>
</template>

<script>
	import LeoHandB from '../TP/LeoHandB.vue'
	import * as util from '@/utils/network'
	import wx from 'weixin-js-sdk'
	import {
		Toast,
		Dialog
	} from 'vant';
	export default {
		components: {
			LeoHandB
		},
		data() {
			return {
				list: [],
				loading: false,
				finished: false,
				activeName: '',
				bannerone: [],
				bannertow: [],
				ggitems: [],
				isFxShow: false,
				isNoData: false,
				pageIndex: 1,
				pageTotal: 0,
				isSc: false,
				re_value: '',
				gcfg: [],
				store: null,
				href: window.location.href,
				collect: '0', //是否收藏,
				recommendData: [],
				storeId: this.$route.query.store_id,
			}
		},
		methods: {
			contentzh(n) {
				let tt = n
				console.log('tt', tt)
				tt = n.replace('/\n/g', '<br>');
				tt = tt.replace('/\r/g', '<br>');
				tt = tt.replace('&nbsp;', '<br>');
				console.log(n)
				return tt;
			},
			onCell() {
				window.location.href = "tel://" + this.store.mobile;
			},
			goPageList(v) {
				this.$router.push({
					path: '/searchpage',
					name: 'SearchPage',
					query: {
						active: v,
						isSj: false
					}
				})
			},
			// 去商品详情页
			goGoodsDetail(v) {
				localStorage.setItem("goodsId", v)
				//leo
				util.redirect('goodsdetail?id=' + v + '&type=spxq&isSj=false');
			},
			// 去查询界面
			goSearchPage() {
				this.$router.push({
					path: '/searchpage',
					name: 'SearchPage',
					query: {
						isSj: false
					}
				})
			},
			// 去店铺信息详情页面
			goShopNamePage() {
				this.$router.push({
					path: 'shopxq'
				})
			},
			// 收藏按钮功能
			/*handelSc() {
				let that = this;
				let msg = "";
				var url = "/addons/litestore/api.account/collect"
				//这里直接调用网络接口
				util.post(url, {
						//store_id: that.store.id
					},
					function(result) {
						Toast(result.msg);
						setTimeout(() => {
							that.getData()
						}, 1000)
					},
				);
			},*/
			onLoad() {
				// 异步更新数据
				// setTimeout 仅做示例，真实场景中一般为 ajax 请求
				let that = this
				// 异步更新数据
				that.pageIndex++;
				setTimeout(() => {
					that.getListData();
				}, 1000)
			},
			// 获取banner数据
			getData() {
				let that = this;
				//util.isToken();
				var url = "/addons/litestore/api.store/mystore";
				var href = window.location.href
				let id = that.storeId ? that.storeId : this.$store.getters.getShop
				//这里直接调用网络接口
				util.post(url, {
						store_id: id,
						href: ''
					},
					function(result) {
						that.ggitems = []
						that.store = result.data.store;
						that.collect = result.data.collect;
						that.bannerone = result.data.banner.top;
						that.bannertow = result.data.banner.bottom;
						if (result.data.banner.left.length > 0) {
							that.ggitems.push(result.data.banner.left);
						}
						if (result.data.banner.right.length > 0) {
							that.ggitems.push(result.data.banner.right);
						}
						that.$store.commit('setShop', result.data.store.id)
						console.log(that.ggitems)
					},
				);
			},
			// 获取列表数据
			getListData() {
				let that = this;
				var url = "/addons/litestore/api.store/shopProductList"
				let id = that.storeId ? that.storeId : this.$store.getters.getShop
				let param = {
					page: that.pageIndex,
					store_id: id
				}
				//这里直接调用网络接口
				util.post(url, param,
					function(result) {
						let data = result.data
						that.loading = false;
						//这里对状态 进行分类
						that.pageTotal = data.total
						if (that.pageTotal < 1) {
							that.isNoData = true
							return;
						}
						if (data.list == null || data.list.length === 0) {
							// 加载结束
							that.finished = true;
							return;
						}
						// 将新数据与老数据进行合并
						that.list = that.list.concat(data.list);

						//如果列表数据条数>=总条数，不再触发滚动加载
						if (that.list.length >= that.pageTotal) {
							that.finished = true;
						}
					},
				);
			},
			getSidebarData() {
				var url = "/addons/litestore/api.category/Showlist"
				let that = this;
				let id = that.storeId ? that.storeId : this.$store.getters.getShop
				//这里直接调用网络接口
				util.get(url, {
						store_id: id
					},
					function(result) {
						that.recommendData = result['data']['categorydata']
					},
				);
			},
		},
		created() {
			this.gcfg = this.$store.getters.getGcfg
			// this.store = this.$store.getters.getShop
			this.getData()
			this.getListData()
			this.getSidebarData()
		},
		watch: {
			"$store.state.gcfg"() {
				this.gcfg = this.$store.getters.getGcfg
			},
			// "$store.state.shop"() {
			// 	this.store = this.$store.getters.getShop
			// }
		}
	}
</script>
<style lang="less" scoped="scoped">
	@import url("../../assets/css/base.less");
	@import url("../../assets/css/listboxless.less");

	.grid-box {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		margin-top: 10px;
		margin: 10px;

		.grid-item {
			display: flex;
			flex-direction: column;
			align-items: center;
			box-sizing: border-box;
		}

		.grid-item2 {
			min-width: 0;
			flex-basis: 48.5%;

			.img {
				height: 110px;
			}
		}

		.grid-item3 {
			min-width: 0;
			flex-basis: 32.5%;

			.img {
				height: 138px;
			}
		}

		.grid-item5 {
			min-width: 0;
			flex-basis: 19.5%;

			.van-icon {
				font-size: 32px;
				padding-top: 10px;
			}

			.name {
				padding-bottom: 10px;
			}
		}

		.grid-item5:first-child {
			border-top-left-radius: 15px;
		}

		.grid-item5:last-child {
			border-bottom-right-radius: 15px;
		}

		.grid-item5:nth-child(5) {
			border-top-right-radius: 15px;
		}

		.grid-item5:nth-child(6) {
			border-bottom-left-radius: 15px;
		}

		.bgcolor {
			color: #fff;

			.name {
				margin-top: 5px;
				font-size: 14px;
				text-align: center
			}
		}

		.bgcolor:nth-child(n+6) {
			color: #000;
		}

		.bgcolor:first-child {
			background: linear-gradient(#f95f55, #fa8051);
		}

		.bgcolor:nth-child(2) {
			background: linear-gradient(#3e87fa, #4daafa);
		}

		.bgcolor:nth-child(3) {
			background: linear-gradient(#6084ff, #649eff);
		}

		.bgcolor:nth-child(4) {
			background: linear-gradient(#20bcaf, #1accbe);
		}

		.bgcolor:nth-child(5) {
			background: linear-gradient(#ff8a3a, #fea444);
		}

		.bgcolor:nth-child(6) {
			background-color: #fef4f2;

			.van-icon {
				color: #fd754d;
			}
		}

		.bgcolor:nth-child(7) {
			background-color: #eff8ff;

			.van-icon {
				color: #4599fc;
			}
		}

		.bgcolor:nth-child(8) {
			background-color: #f1f3ff;

			.van-icon {
				color: #7e84fe;
			}
		}

		.bgcolor:nth-child(9) {
			background-color: #ecfbf8;

			.van-icon {
				color: #50d2b6;
			}
		}

		.bgcolor:nth-child(10) {
			background-color: #fff9f1;

			.van-icon {
				color: #fd802c;
			}
		}
	}

	.grid-box5 {
		justify-content: space-around;
	}

	.grid-box5 {
		.grid-item5+.grid-item5 {
			// margin-left: 5px;
		}
	}
</style>
